import { EditOutlined } from '@ant-design/icons';
import { Avatar, Button, Descriptions, Divider, Flex, Skeleton, Typography } from 'antd';
import Parser from 'html-react-parser';
import { useContext, useState } from 'react';
import Search from 'src/assets/icons/search.png';
import Icon from 'src/components/v2/Icon';
import { TicketStatusTag } from 'src/components/v2/Tag/TicketStatusTag/TicketStatusTag';
import urlPath from 'src/constants/urlPath';
import { AppContext } from 'src/contexts/app.context';
import { useChatStore } from 'src/stores/chatStore';
import { formatDateTime } from 'src/utils/utils';
import './TopicAbout.scss';
import TopicRenameModal, { RenameTopicOpenType } from './components/TopicRenameModal';

const { Paragraph, Text } = Typography;

type Props = {
  topicId: string;
  setOpenAddMember: React.Dispatch<React.SetStateAction<boolean>>;
  setShowSearch: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function TopicAbout({ topicId, setOpenAddMember, setShowSearch }: Props) {
  const { setTicketSelected } = useContext(AppContext);
  const rooms = useChatStore((state) => state.rooms);
  const currentTopic = rooms[topicId as string]; // ← Lấy từ store

  const [isFetching] = useState(false);
  const [renameModalOpen, setRenameModalOpen] = useState<RenameTopicOpenType>({ isOpen: false });

  const handleOpenEditName = () => {
    setRenameModalOpen({ isOpen: true, topicId });
  };

  return (
    <Flex vertical className='topic-detail-about'>
      <Flex vertical gap={15}>
        <Flex gap={24} justify='center' style={{ marginTop: 8 }} className='about-btn-rows'>
          <Flex vertical align='center' className='btn' onClick={() => setShowSearch(true)}>
            {isFetching ? (
              <Skeleton.Avatar size={38} style={{ marginBottom: 8 }} />
            ) : (
              <Avatar className='topic-about-avatar' size={38} icon={<Icon url={Search} size={'100%'} />} />
            )}
            <Text className='about-title-btn'>Tìm kiếm</Text>
          </Flex>
        </Flex>
        <Flex vertical align='center'>
          {isFetching ? (
            <Skeleton.Input active size='small' block style={{ width: '60%', display: 'flex', marginInline: 'auto' }} />
          ) : (
            <Flex align='center' gap={8}>
              {currentTopic?.name ? (
                <Text className='about-title'>{currentTopic?.name}</Text>
              ) : (
                <Text type='secondary'>Chưa có tên nhóm chat</Text>
              )}
              <Button type='primary' shape='circle' size='small' icon={<EditOutlined />} onClick={handleOpenEditName} />
            </Flex>
          )}
        </Flex>
      </Flex>
      <Divider />
      <Skeleton loading={isFetching} paragraph={{ rows: 3 }} active>
        <Descriptions
          labelStyle={{
            minWidth: '80px'
          }}
          size='small'
          column={1}
        >
          <Descriptions.Item label='Mã ticket'>
            <Flex gap={20} justify='space-between' align='center'>
              <Text strong copyable>
                {currentTopic?.ticket?.ticketCode}
              </Text>
            </Flex>
          </Descriptions.Item>
          <Descriptions.Item label='Vấn đề'>
            <Text strong>{currentTopic?.ticket?.ticketCategory?.name}</Text>
          </Descriptions.Item>
          <Descriptions.Item label='Người tạo'>{currentTopic?.ticket?.createdByObj?.name}</Descriptions.Item>
          <Descriptions.Item label='Ngày tạo'>{formatDateTime(currentTopic?.ticket?.createdDate)}</Descriptions.Item>
          <Descriptions.Item label='Trạng thái'>
            <TicketStatusTag ticketStatus={currentTopic?.ticket?.ticketStatus} />
          </Descriptions.Item>
          <Descriptions.Item
            label='Mô tả'
            style={{
              paddingBottom: 0
            }}
          >
            <Paragraph
              style={{
                marginBottom: 0
              }}
              className='about-remark'
            >
              {Parser(currentTopic?.ticket?.remark ?? '')}
            </Paragraph>
          </Descriptions.Item>
        </Descriptions>
        <Button
          block
          className='about-link'
          onClick={() => {
            if (currentTopic?.ticketId) {
              setTicketSelected(currentTopic.ticketId);
              window.open(`${urlPath.myTicket.location}/${currentTopic.ticketId}`, '_blank');
            } else {
              console.warn('⚠️ No ticketId found in current topic');
            }
          }}
        >
          Xem chi tiết
        </Button>
      </Skeleton>
      {renameModalOpen.isOpen && <TopicRenameModal open={renameModalOpen} setOpen={setRenameModalOpen} />}
    </Flex>
  );
}
